import { Component } from '@angular/core';

@Component({
	selector: 'app-timetable-transport-lists',
	templateUrl: './timetable-transport-lists.component.html',
	styleUrls: ['./timetable-transport-lists.component.css'],
})
export class TimetableTransportListsComponent {
	constructor() {}
}
